import { renderCMSComponent } from "~/features/cms/componentFactory";
import { getOccTransport } from "~/common/api/occTransport";

import { useState } from "react";
import type { SchaefflerFormDTO } from "~/features/cms/types/dto";

export const useSchaefflerForm = (formId: string, onSuccess?: () => void) => {
  const [form, setForm] = useState<SchaefflerFormDTO | null>(null);
  const [loading, setLoading] = useState(false);

  return {
    renderForm: () => (form ? renderCMSComponent({ ...form, onSuccess }) : null),
    loadForm: async () => {
      if (loading || form) {
        return;
      }
      setLoading(true);
      const formData = await fetchForm(formId);
      setForm(formData ?? null);
      setLoading(false);
    },
    loading,
  };
};

const forms: Record<string, Promise<SchaefflerFormDTO> | undefined> = {};
const fetchForm = (formId: string) => {
  if (forms[formId]) {
    return forms[formId];
  }

  forms[formId] = fetchSchaefflerForm(formId);
  return forms[formId];
};

export const fetchSchaefflerForm = async (formId: string): Promise<SchaefflerFormDTO> => {
  const { request, url } = getOccTransport();
  const response = await request(
    url(`/contact-form/${encodeURIComponent(formId)}`),
    {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    },
    { accountContext: "omit" },
  );
  if (!response.ok) {
    throw new Error("Error fetching product");
  }
  return (await response.json()) as SchaefflerFormDTO;
};
